import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../../styles/confirm-modal.css';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmation Required',
  badge = 'Atelier Action',
  message,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary', // 'primary' | 'danger' | 'warning'
  icon = 'ri-question-line',
  isLoading = false,
}) => {
  // Close on ESC key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen && !isLoading) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, isLoading, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="confirm-modal__backdrop" onClick={!isLoading ? onClose : undefined}>
          <motion.div
            className="confirm-modal"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.94, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 12 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            <div className="confirm-modal__header">
              <div className={`confirm-modal__icon-box ${confirmVariant}`}>
                <i className={icon}></i>
              </div>
              <div className="confirm-modal__title-area">
                {badge && <span className="confirm-modal__badge">{badge}</span>}
                <h4 className="confirm-modal__title">{title}</h4>
              </div>
            </div>

            <div className="confirm-modal__body">
              {message && <p className="m-0">{message}</p>}
              {children}
            </div>

            <div className="confirm-modal__actions">
              <button
                type="button"
                className="confirm-modal__btn-cancel"
                onClick={onClose}
                disabled={isLoading}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className={`confirm-modal__btn-confirm ${confirmVariant}`}
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <i className="ri-loader-4-line ri-spin"></i>
                    <span>Processing...</span>
                  </>
                ) : (
                  confirmText
                )}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmModal;
